module.exports = __webpack_public_path__ + "fed9ed37835a1d6a60f06cef43358593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/012.jpg
// module id = 57
// module chunks = 0